import { render } from "./MembershipLocaleSwitcher.vue?vue&type=template&id=93758916"
import script from "./MembershipLocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./MembershipLocaleSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__